module.exports = __webpack_public_path__ + "cr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/cr.svg
// module id = 501
// module chunks = 0